import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from './ui/card';
import { 
  Image, 
  Sparkles, 
  Heart, 
  BookOpen,
  Star,
  Cross
} from 'lucide-react';

export const FeaturesSection = () => {
  const { t, language } = useLanguage();

  const features = [
    {
      icon: Image,
      title: t('features.saintImage.title'),
      description: t('features.saintImage.description'),
      color: 'text-gold',
      bgColor: 'bg-gold/10'
    },
    {
      icon: Sparkles,
      title: t('features.archangelImage.title'),
      description: t('features.archangelImage.description'),
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      icon: Heart,
      title: t('features.personalPrayer.title'),
      description: t('features.personalPrayer.description'),
      color: 'text-burgundy',
      bgColor: 'bg-burgundy/10'
    },
    {
      icon: BookOpen,
      title: t('features.history.title'),
      description: t('features.history.description'),
      color: 'text-navy',
      bgColor: 'bg-navy/10'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gradient-to-b from-secondary/30 to-background">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex justify-center mb-6">
            <div className="flex items-center gap-4">
              <div className="h-px w-16 bg-gradient-to-r from-transparent to-gold/50" />
              <Cross className="w-5 h-5 text-gold" />
              <div className="h-px w-16 bg-gradient-to-l from-transparent to-gold/50" />
            </div>
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-foreground mb-4">
            {t('features.title')}
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
            {t('features.subtitle')}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <Card 
              key={index}
              className="card-divine group cursor-pointer"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CardContent className="pt-8 pb-6 px-6 text-center flex flex-col h-full">
                <div className={`w-16 h-16 mx-auto mb-6 rounded-2xl ${feature.bgColor} flex items-center justify-center transition-transform duration-300 group-hover:scale-110`}>
                  <feature.icon className={`w-8 h-8 ${feature.color}`} />
                </div>
                <h3 className="font-heading text-xl font-semibold text-foreground mb-3">
                  {feature.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed mt-auto">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Decorative Element */}
        <div className="flex justify-center mt-16">
          <div className="flex items-center gap-3">
            <Star className="w-4 h-4 text-gold/40" />
            <Star className="w-5 h-5 text-gold/60" />
            <Star className="w-6 h-6 text-gold" />
            <Star className="w-5 h-5 text-gold/60" />
            <Star className="w-4 h-4 text-gold/40" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
